import {DropdownFieldOptions} from "../../../../../types/form/controls"
import {countries} from "../../../../../config/geography/countries"

export const composeCountryOptions = (): DropdownFieldOptions => {
    return countries.map(c => ({id: c.countryShortCode, name: c.countryName}))
}
